// extracted by mini-css-extract-plugin
module.exports = {"container":"AddMeal_container__3YQys","containerInput":"AddMeal_containerInput__1fAwc","invalidInp":"AddMeal_invalidInp__1X6wv"};